import { render } from "./PfInputText.vue?vue&type=template&id=148b5470"
import script from "./PfInputText.vue?vue&type=script&lang=js"
export * from "./PfInputText.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__